import React from "react";

const BookRow = ({ matchingBook, message = null }) => {
    return (
        <tr>
            <td>
                <div>
                    <img
                        src={matchingBook.cover_image}
                        alt={`${matchingBook.title} cover`}
                    />
                </div>
            </td>
            <td valign="top" className="col-sm-7 col-lg-8">
                <div className="modal-book-text">
                    <div className="modal-book-title">{matchingBook.title}</div>
                    {message ? (
                        <div className="modal-book-message error">
                            {message}
                        </div>
                    ) : null}
                </div>
            </td>
            <td valign="top">
                <div className={`modal-book-isbn ${message ? " error" : ""}`}>
                    {matchingBook.isbnStr}
                </div>
            </td>
        </tr>
    );
};

export default BookRow;



// WEBPACK FOOTER //
// ./src/components/modal-page/table-rows/BookRow.js